module.exports = __webpack_public_path__ + "static/media/fankui.2e90b632.svg";